import React from 'react'
import AdminFilterTrigger from '../../AdminFilterTrigger'

type AdminCustomersActionBarProps = {
  startIndex: number
  endIndex: number
  totalItems: number
  hasActiveFilters: boolean
  activeFiltersDescriptions: string
  onOpenFilters: () => void
}

const AdminCustomersActionBar: React.FC<AdminCustomersActionBarProps> = ({
  startIndex,
  endIndex,
  totalItems,
  hasActiveFilters,
  activeFiltersDescriptions,
  onOpenFilters
}) => {
  return (
    <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-sm text-gray-600">
            Exibindo{' '}
            <span className="font-semibold text-gray-900">
              {totalItems === 0 ? 0 : startIndex} - {endIndex}
            </span>{' '}
            de{' '}
            <span className="font-semibold text-gray-900">{totalItems}</span>{' '}
            clientes
          </p>
          {hasActiveFilters && (
            <p className="mt-1 text-xs text-blue-600">
              Filtros aplicados: {activeFiltersDescriptions}
            </p>
          )}
        </div>
        <AdminFilterTrigger
          onClick={onOpenFilters}
          hasActiveFilters={hasActiveFilters}
        />
      </div>
    </div>
  )
}

export default AdminCustomersActionBar

